export default "__VITE_PUBLIC_ASSET__929c892b__"